<template>
	<div>
		<router-view v-show="$route.matched.length==3"></router-view>
		<PageHeaderLayout v-show="$route.matched.length==2">
			<div class="main-page-content">
				<el-form :inline="true" :model="searchCondition">
					<el-form-item label="姓名">
						<el-input v-model="searchCondition.fullname" placeholder="请输入姓名" class="item-name" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="公司名称">
						<el-select  v-model="searchCondition.company_id"  filterable clearable class="seliput settlement">
						<el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="身份证">
						<el-input v-model="searchCondition.idcard" placeholder="请输入身份证" class="item-id_number"
							clearable></el-input>
					</el-form-item>
					<el-form-item label="时间">
						<el-date-picker value-format='yyyy-MM-dd' v-model="date" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button @click="searchButton" style="color: #1890ff">查询</el-button>
					</el-form-item>
				</el-form>

				<div class="main-table-header">
					<h2></h2>
					<el-button v-if="userPermissions.includes('white_add')" style="margin:0 0 20px 20px;"
						type="primary" size="medium" @click="AddWhiteList">
						添加白名单
					</el-button>
				</div>
				<el-row>
				
				</el-row>
				<ApeTable ref="apeTable" v-if="userPermissions.includes('white_list')" :data="bossWhiteList" :columns="columns" :loading="loadingStaus"
					:pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
					<el-table-column
					slot="first-column"
					align="center"
					label="公司名称">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="scope.row.id+''" placement="top">
					<div>{{ scope.row.company_name }}</div>
					</el-tooltip>
					</template>
					</el-table-column>
					<el-table-column width="160" header_align='center' align='center' label="操作">
						<template slot-scope="scope">
							<span>
								<el-popover placement="top" width="150" v-model="scope.row.visible">
									<p>确定要删除记录吗？</p>
									<div style="text-align: right; margin: 0;">
										<el-button type="text" size="mini" @click="scope.row.visible=false">取消
										</el-button>
										<el-button type="danger" size="mini" @click="deleteWhiteList(scope.row.id)">确定
										</el-button>
									</div>
									<el-button v-if="userPermissions.includes('white_delete')" type="danger"
										slot="reference">删除</el-button>

								</el-popover>
							</span>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
		<add-white-list ref='addWhiteList' title='添加董监高白名单' @refresh='init'></add-white-list>
	</div>
</template>

<script>
	import PageHeaderLayout from '@/layouts/PageHeaderLayout'
	import ApeTable from '@/components/ApeTable'
	import addWhiteList from './addWhiteList.vue'
	import DatePicker from '@/components/DatePicker.vue'
	import ScreeCompany from '@/components/ScreeCompany.vue'
	import {
		mapGetters,
	} from 'vuex'

	export default {
		components: {
			PageHeaderLayout,
			ApeTable,
			addWhiteList,
			DatePicker,
			ScreeCompany
		},
		data() {
			return {

				// 搜索条件
				searchCondition: {
					fullname: '',
					idcard: '',
					company_id:'',
					channel_account:''
				},
				companyList:[],
				date: ['',''],
				loadingStaus: true,
				columns: [{
						title: '姓名',
						value: 'fullname',
						header_align: 'center',
						align: 'center',
					}, {
						title: '身份证号',
						value: 'idcard',

						header_align: 'center',
						align: 'center',
					},
					{
						title: '添加时间',
						value: 'created_at',
						header_align: 'center',
						align: 'center',
					},
				],

				// 表格列表数据
				bossWhiteList: [],
				// 分页信息
				pagingData: {
					is_show: true,
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0
				},
				// 分页的offset,序号列使用
				offset: 0,
			}
		},

		computed: {
			...mapGetters(['userPermissions']),
		},
		watch: {
			"$route.matched": function(n) {
				if (n.length === 2) {
					this.init()
				}
			}
		},
		methods: {
			
			// 搜索
			searchButton() {
				this.date=this.date||['','']
				console.log(this.date)
				this.init()
				
			},
			// 切换页码操作
			async switchPaging() {
				this.init()
			},

			// 添加白名单
			async AddWhiteList() {

				this.$refs.addWhiteList.open()
			},

			// 删除白名单
			async deleteWhiteList(id) {
				let res = await this.$api.deleteCompany_djg_userID(id)
				if (res) {
					this.$message({
						message: `删除成功`,
						type: 'success'
					});
					this.init()
				}
			},

			// 初始化列表
			async init() {
				let pagingInfo = this.$refs['apeTable']?.getPagingInfo() || {
					page_size: 10,
					current_page: 1
				}
				this.loadingStaus = true
				let res = await this.$api.getCompany_djg_userlist({
					...pagingInfo,
					...this.searchCondition,
					start_time:this.date[0],
					end_time:this.date[1]
				})

				this.bossWhiteList = res.data || []
				this.$nextTick(() => {
					this.loadingStaus = false
				})
				this.pagingData.total = res.pages.total
				this.offset = res.pages.offset
			},
		async	getUserCompanyList (){
				let result = await this.$api.getUserCompanyList()
				this.companyList = result
			}
		},
		created() {
			this.getUserCompanyList()
		},
		mounted() {
			this.init()
		},
	}
</script>

<style lang="scss" scoped>
	.main-page-content {
		position: relative
	}

	.main-table-header {
		display: flex;
		justify-content: space-between;
		padding-right: 20px;
		box-sizing: border-box;
	}
</style>
